export const rateCodesMap = {
  F40: '40-year fixed',
  F30: '30-year fixed',
  F29: '29-year fixed',
  F28: '28-year fixed',
  F27: '27-year fixed',
  F26: '26-year fixed',
  F25: '25-year fixed',
  F24: '24-year fixed',
  F23: '23-year fixed',
  F22: '22-year fixed',
  F21: '21-year fixed',
  F20: '20-year fixed',
  F19: '19-year fixed',
  F18: '18-year fixed',
  F17: '17-year fixed',
  F16: '16-year fixed',
  F15: '15-year fixed',
  F14: '14-year fixed',
  F13: '13-year fixed',
  F12: '12-year fixed',
  F11: '11-year fixed',
  F10: '10-year fixed',
  F5: '5-year fixed',
  A1_1: '1/1 ARM',
  A3_1: '3/1 ARM',
  A5_1: '5/1 ARM',
  A2_1: '2/1 ARM',
  A7_1: '7/1 ARM',
  A10_1: '10/1 ARM',
  A15_1: '15/1 ARM',
  A5_5: '5/5 ARM',
}

export const loanTermToMonthsMap = {
  F30: 360,
  F29: 348,
  F28: 336,
  F27: 324,
  F26: 312,
  F25: 300,
  F24: 288,
  F23: 276,
  F22: 264,
  F21: 252,
  F20: 240,
  F19: 228,
  F18: 216,
  F17: 204,
  F16: 192,
  F15: 180,
  F14: 168,
  F13: 156,
  F12: 144,
  F11: 132,
  F10: 120,
  A5_6: 360,
  A7_6: 360,
  A10_6: 360,
  ALL: 360,
}
